import fauna, { Call, IsArray } from 'faunadb'
import { retrieveErrorAndDescription } from '../../../backend/routes/api-errors'
import * as backendAPI from './backend-api'
import { handleDataLoadingError } from './fauna-api-errors'

import { recursivelyRemoveRefAndData } from './utils';

class FaunaAPI {
  constructor() {
    this.client = this.getClient(localStorage.getItem('REACT_APP_LOCAL___PUBLIC_BOOTSTRAP_KEY'))
    this.logout = this.logout.bind(this)
    this.getClient = this.getClient.bind(this)
    this.lastRefresh = null
  }

  /** ******* Authentication is delegated through the backend *********/
  async login(email, password) {
    return await backendAPI.login(email, password).then(loginResult => {
      if (!loginResult.error) {
        this.client = this.getClient(loginResult.secret)
        this.lastRefresh = Date.now()
      }
      return loginResult
    })
  }

  async logout(all) {
    return await backendAPI.logout(all).then(res => {
      this.client = this.getClient(localStorage.getItem('REACT_APP_LOCAL___PUBLIC_BOOTSTRAP_KEY'))
      return res
    })
  }

  async requestReset(username) {
    return await backendAPI.requestReset(username)
  }

  async refreshToken() {
    return await backendAPI.refreshToken().then(res => {
      if (res.secret) {
        this.client = this.getClient(res.secret)
        return res
      } else {
        return res
      }
    })
  }

  async resendVerificationEmail(email) {
    return await backendAPI.resendVerificationEmail(email)
  }

  async verifyEmail(token) {
    return await backendAPI.verifyEmail(token)
  }

  /** ******* Calls directly to Fauna*********/
  async changePassword(oldPassword, newPassword) {
    return this.client.query(Call('change_password', oldPassword, newPassword))
  }

  async resetPassword(password, token) {
    const resetClient = this.getClient(token)
    return resetClient.query(Call('reset_password', password))
  }

  async callFunction(functionName, payload) {
    return new Promise((resolve, reject) => {
      this.callWithRefreshRetry(() => this.client.query(Call(functionName, payload)))
      .then(res => resolve(recursivelyRemoveRefAndData(res)))
      .catch(err => {
        reject(handleDataLoadingError(err))
      })
    })
  }

  /** ******* Helpers *********/
  /* Helper wrapper that will catch failed queries and retry in case permission was denied. */
  async callWithRefreshRetry(queryFn) {
    return queryFn()
      .then(res => {
        return res
      })
      // .catch(async err => {
      //   const errorAndCode = retrieveErrorAndDescription(err)
      //   if (errorAndCode && errorAndCode.code === 'unauthorized') {
      //     await this.refreshAndRetry(queryFn)
      //   } else {
      //     throw err;
      //   }
      // })
  }

  async refreshAndRetry(queryFn) {
    return this.refreshToken()
      .then(res => {
        if (res) return queryFn()
      })
      .catch(err => {
        throw err;
      })
  }

  getClient(secret) {
    const opts = { secret: secret, keepAlive: false }
    if (localStorage.getItem('REACT_APP_LOCAL___FAUNADB_DOMAIN'))
      opts.domain = localStorage.getItem('REACT_APP_LOCAL___FAUNADB_DOMAIN')
    if (localStorage.getItem('REACT_APP_LOCAL___FAUNADB_SCHEME'))
      opts.scheme = localStorage.getItem('REACT_APP_LOCAL___FAUNADB_SCHEME')
    if (localStorage.getItem('REACT_APP_LOCAL___FAUNADB_PORT'))
      opts.port = localStorage.getItem('REACT_APP_LOCAL___FAUNADB_PORT')
    opts.headers = { 'X-Fauna-Source': 'fauna-auth-skeleton-backend' }

    const client = new fauna.Client(opts)
    if (this.client) {
      // To ensure that the new client sees everything the old client saw.
      const lastTxTime = this.client.getLastTxnTime()
      client.syncLastTxnTime(lastTxTime)
    }
    return client
  }
}

const faunaAPI = new FaunaAPI()
export { faunaAPI }
